import { render, staticRenderFns } from "./duplicate-brochures.vue?vue&type=template&id=2c258d9a&"
import script from "./duplicate-brochures.vue?vue&type=script&lang=js&"
export * from "./duplicate-brochures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports